import React, { useEffect, useState, useRef, useCallback  } from 'react';
import { Container, Row, Col, Form, Table } from "react-bootstrap";
import { Link,useNavigate } from 'react-router-dom';
import * as AuthVerify from '../../lib/common';
import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "../InputField/InputField";
import {BASE_URL} from '../../lib/constant';
import Axios from '../../lib/axios/axiosInstance';
import Modal from 'react-bootstrap/Modal';
import ApprovalLoop from './ApprovalLoop'
import { Slide, toast } from 'react-toastify';
import Loader from '../Common/loader';

const OrderDetails = ({ confirmedOrder,pendingOrder,status }) => {
    const navigate = useNavigate();
    const [cartDetails, setCartDetails] = useState(false);
    const [saveAsTemplateModal, setSaveAsTemplateModal]=useState(false);
    const [confirmOrder, setConfirmOrder] = useState(false);
    const [templateOrder, setTemplateOrder] = useState(false);
    const [userDetails, setUserDetails] = useState(false); 
    const [draftOrder, setDraftOrder] = useState(false); 
    const [askingForDraft, setAskingForDraft] = useState(false);
    const [loadBudgetData, setLoadBudgetData] = useState(false);
    const [showConfirmButton, setShowConfirmButton] = useState(false);
    const [showReOrderButton, setShowReOrderButton] = useState(false);
    const [showRefundButton, setShowRefundButton] = useState(false);
    const [showRefundModal, setShowRefundModal] = useState(false);
    const [showExchangeModal, setShowExchangeModal] = useState(false);
    const [selectedProductDetails, setSelectedProductDetails] = useState(false);
    const [newSelectedProductDetails, setNewSelectedProductDetails] = useState(false);
    const [suggestedProducts, setSuggestedProducts] = useState(false);
    const [reOrder, setReOrder] = useState(false);
    const [itemEditable , setItemEditable] = useState(false);
    const [allowPOEdit, setAllowPOEdit] = useState(false);

    const getDateTime = () =>{
        const today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const formattedToday = dd + '-' + mm + '-' + yyyy;
        return formattedToday;
    }

    const checkCartItems = async (isReOrder=false) => {
        setReOrder(isReOrder);
        await AuthVerify.getCartDeatils(true).then(async data => {
            if(data?.items?.length > 0) {
                setAskingForDraft(true);
            }else{
                loadToCart();
            }
        })
    }

    const saveAsTemplate = async (values) =>{
        if(!cartDetails?.carth?.refnum)window.location.href = '/';
        var body = {
            "template": {
                "templatename":values.templateName,
                "remark":values.templateRemarks
            }
        }
      
        // Save As Template
        // api/cart/savetemplate/:refnum
        await Axios.post(`/cart/savetemplate/${cartDetails?.carth?.refnum}`,body)
        .then(function (response) {
            if (response && response.data?.data?.template) {
              setSaveAsTemplateModal(false);  
              toast.success("Successfully saved as template.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
              });
            }
            else {
            toast.error(response.statusText, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
                });
              setSaveAsTemplateModal(false);
              return false;
            }
        })
        .catch(function (error) {
            setSaveAsTemplateModal(false);
            return false;
        });
    }

    const loadToCart = async (newCart,asDraft=false) => {
        let refnum =newCart?newCart.refnum:cartDetails?.carth?.refnum
        if(reOrder){
            setAskingForDraft(false);
            // Reorder
            // /api/cart/copy
            await Axios.post(`/cart/copy`,
            {
                order:{
                    refnum: cartDetails?.carth?.refnum
                }
            })
            .then(async (data) => {
                if(data?.data?.success){
                    toast.success(`All Items loaded into cart successfully.`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                    if(asDraft)setActiveCCandC(refnum);
                    else {
                        navigate("/my-account");
                    }
                }else{
                    toast.error(`Items loaded into cart failed.`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            });
        }
        else{
            // Load to cart
            // https://devb2b.bizpoint-intl.com:3082/api/cart/updatestatus/:refnum
            await Axios.post(`/cart/updatestatus/${refnum}`,
            {
                status:{
                    newstatus: "open"
                }
            })
            .then(async (data) => {
                if(data?.data?.data?.updatecartstatus=='1'){
                    toast.success(`Items loaded into cart successfully.`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                    setActiveCCandC();
                }else{
                    toast.error(`Items loaded into cart failed.`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            });
        }
        
    }

    const confirmOrderHandler =async ()=>{
        var values=cartDetails;
        // const selectedShippingAddress= addressDetails.filter(x=>x.dellocname==shippingAddress)[0];
        const refnum=values.carth.refnum;
        const val = {
          carth: {
            refnum: refnum,
            billaddr1: values.carth.billaddr1,
            billaddr2: values.carth.billaddr2,
            billaddr3: null,
            billcity: values.carth.billcity,
            billcountry: values.carth.billcountry,
            billstate: values.carth.billstate,
            billpostcode: values.carth.billpostcode,
            billphone: values.carth.billphone,
            billemail: values.carth.billemail,
            shipptc: values.carth.shipptc,
            shipemail: values.carth.shipemail,
            shipphone: values.carth.shipphone,
            shipaddr1: values.carth.shipaddr1,
            shipaddr2: values.carth.shipaddr2,
            shipaddr3: null,
            shipcity: values.carth.shipcity,
            shipcountry: values.carth.shipcountry,
            shipstate: values.carth.shipstate,
            shippostcode: values.carth.shippostcode,
            orderremark1:values.carth.orderremark1,
            billptc:values.carth.billptc,
            shipptc:values.carth.shipptc,
            items:values.items,
            ponum:values.carth.ponum,
            budgetnum: values.carth.budgetnum,
            paymode:values.carth.paymode,
            shipmode:values.carth.shipmode,
            allowpartial:values.carth.allowpartial,
            shipdeldateremark: values.carth.shipdeldateremark
          }
        }
        await Axios.post(`/cart/confirm/${refnum}`,val)
        .then(async (refnum) => {
            if (refnum?.data && refnum?.data.carth && refnum.status == 200) {
                userDetails.items={};
                AuthVerify.setSession(userDetails);
                toast.success('Order Confirmed Successfully !', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            }else{
                let toastMsg = "";
                refnum?.data.errordetail.map(error=>{
                    toastMsg+=error.error+"\n"
                })
                toast.success(toastMsg, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            }
        })
        .catch(e=>{
            console.log(e)
        });
    }

    const updatePOHandler =async ()=>{
        var values=cartDetails;
        // const selectedShippingAddress= addressDetails.filter(x=>x.dellocname==shippingAddress)[0];
        const refnum=values.carth.refnum;
        const val = {           
            refnum: refnum,
            ponum:values.carth.ponum,
        }
        await Axios.post(`/cart/updateponum/`,val)
        .then(async (refnum) => {
            if (refnum?.data && refnum?.data.carth && refnum.status == 200) {
                toast.success('PO Updated Successfully !', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            }else{
                let toastMsg = "";
                refnum?.data.errordetail.map(error=>{
                    toastMsg+=error.error+"\n"
                })
                toast.success(toastMsg, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            }
        })
        .catch(e=>{
            console.log(e)
        });
    }

    const saveAsDraft = async () => {
        setAskingForDraft(false);
        await AuthVerify.saveAsDraft().then(async result => {
            if(result){
                const currentRefnum=cartDetails?.carth?.refnum;
                await AuthVerify.getCartRef(true,currentRefnum).then(newCart=>{
                    if(newCart){
                        loadToCart(newCart,true);
                    }
                })
            }
        });
    }
 
    const setActiveCCandC =async (newRef) => {
        var session = AuthVerify.getUser();
        session.refnum = newRef??cartDetails?.carth?.refnum;
        AuthVerify.setSession(session);
        
        const data={
          costcentersetting: {
            ccnum: cartDetails?.carth?.ccnum,
            catalognum: cartDetails?.carth?.catalognum
          }
        }
        await Axios.post(`/account/costcenter`,data)
          .then(async (data) => {
            if(data.data?.data){
                // loadToCart();
                navigate("/my-account");
            }
        });
        return false;
    };

    const loadBudget = async (carth) =>{
        const session = AuthVerify.getUser();
        if(!session)window.location.href = '/';
        // setShowConfirmButton(session.applycorpsetting);
        //if(budgetnum)session.budgetnum=budgetnum;
        await Axios.get(`/cart/budget/${carth.refnum}`)
        .then(function (response) {
            if (response && response.data?.data?.budgets) {
                let data=response.data?.data.budgets.filter(x=>x.budgetnum==carth.budgetnum)[0];
                setLoadBudgetData(data);
            }
        })
        
    }

    const getInitiator =()=>{
        if(status === "Confirmed")setConfirmOrder(true);
        if(pendingOrder){
            AuthVerify.getCartDeatils(true,pendingOrder.refnum)
            .then(async (data) => {
                setItemEditable(data.carth.itemeditable??false);
                setAllowPOEdit(data.carth.approver1access || data.carth.approver2access || data.carth.approver3access);
                setShowReOrderButton(data.carth.reorderbtndisplay);
                setShowConfirmButton(data.carth.confirmbtndisplay);
                setShowRefundButton(data.carth.returndisplay);
                loadBudget(data.carth);
                setCartDetails(data);
                setUserDetails(AuthVerify.getUser());
                if(pendingOrder.draftOrder==='true'){
                    setDraftOrder(true);
                }
            });
        }else{
            setConfirmOrder(true);
            AuthVerify.getCartDeatils(true).then(async (data) => {
                setShowReOrderButton(data.carth.reorderbtndisplay);
                setShowRefundButton(data.carth.returndisplay);
                loadBudget(data.carth.budgetnum);
                setCartDetails(data);
                await AuthVerify.getCartRef(true).then((userDetails) => {
                    setUserDetails(userDetails);
                });
            });
        }
    }

    useEffect(() => {
        getInitiator();
    }, []);

    const handleRefundorExchange = async (refund,exchange,matnum) => {
        var item=cartDetails.items.filter(x=>x.matnum==matnum)[0];
        setSelectedProductDetails(item);
        setNewSelectedProductDetails(false);
        if(refund){
            setShowRefundModal(true);
        }
        else if (exchange){
            // Get Suggested Products for Exchange
            // /account/order/:refnum/exchangeitem/:matnum
            await Axios.get(`/account/order/${cartDetails?.carth?.refnum}/exchangeitem/${matnum}`)
            .then(async (data) => {
                if(data?.data?.data?.items){
                    setSuggestedProducts(data?.data?.data?.items);
                    setShowExchangeModal(true);
                }
            });
        }
    }

    const handleRefundorExchangeSubmit=async (refund,exchange,values)=>{
        if(refund){
            // Submit request
            // /account/order/:refnum/salesreturn
            await Axios.post(`/account/order/${cartDetails?.carth?.refnum}/salesreturn`,
            {
                "salesreturn": {
                    "requesttype": "refund",
                    "reason": values.reason,
                    "matnum": selectedProductDetails.matnum,
                    "qty": values.qty,
                    "newmatnum": values.newmatnum
                }
            })
            .then(async (data) => {
                if(data?.data?.success && data?.data?.data?.items){
                    setShowRefundModal(false);
                    toast.success('Refund request submitted successfully !', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
                else{
                    setShowRefundModal(false);
                    toast.error(data.statusText, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            });
        }
        else if(exchange){
            // Submit request
            // /account/order/:refnum/salesreturn
            await Axios.post(`/account/order/${cartDetails?.carth?.refnum}/salesreturn`,
            {
                "salesreturn": {
                    "requesttype": "exchange",
                    "reason": values.reason,
                    "matnum": selectedProductDetails.matnum,
                    "qty": values.qty,
                    "newmatnum": values.newmatnum
                }
            })
            .then(async (data) => {
                if(data?.data?.success && data?.data?.data?.items){
                    setShowExchangeModal(false);
                    toast.success('Exchange request submitted successfully !', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
                else{
                    setShowExchangeModal(false);
                    toast.error(data.statusText, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            });
        }
        setNewSelectedProductDetails(false);
    }

    async function deleteCartItems(e, itemDetails) {
        e.preventDefault();

        setCartDetails(false);
        await AuthVerify.deleteCartItems(itemDetails.uuid,pendingOrder.refnum)
            .then(function (result) {
                // cartDetails.items = result.items;
                // cartDetails?.carth?.totalamt = result.summary.totalamt;
                // cartDetails?.carth?.shippingamt = result.summary.shippingamt;
                // cartDetails?.carth?.gstamt = result.summary.gstamt;
                // cartDetails?.carth?.grossamt = result.summary.subamt;
                // setCartDetails(cartDetails);
                getInitiator();
            });
    }

    async function updateCartItems(e, itemDetails, qty, direct = false) {
        e.preventDefault();

        setCartDetails(false);
        if (direct) {
            itemDetails.qty = parseInt(qty);
        } else {
            itemDetails.qty += qty;
        }

        await AuthVerify.addTocart(itemDetails, { qty: itemDetails.qty }, true,pendingOrder.refnum).then(function (result) {
            // cartDetails.items = result.items;
            // cartDetails?.carth?.totalamt = result.summary.totalamt;
            // cartDetails?.carth?.shippingamt = result.summary.shippingamt;
            // cartDetails?.carth?.gstamt = result.summary.gstamt;
            // cartDetails?.carth?.grossamt = result.summary.subamt;
            // setCartDetails(cartDetails);
            getInitiator();
        });
    }

    const [selectedCartItem, setSelectedCartItem] = useState(false);
    const [customsDetails, setCustomsDetails] = useState([]);
    const [showCustomsDetails, setShowCustomsDetails] = useState(false);
    const handleShowCustomsDetails = async (item) => {
        setSelectedCartItem(item);
        var refnum = item.refnum;
        await Axios.get(`cart/cartcustomsdetails/${refnum.replace('ODR','CAR')}/${item.matnum}`)
            .then(function (response) {
                if (response && response.data?.success) {
                    setCustomsDetails(response.data.data);
                    setShowCustomsDetails(true);
                }
                else {
                    toast.error("Unable to retrieve details", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                    setShowCustomsDetails(false);
                }
            })
    }

    const [previewLoading, setPreviewLoading] = useState(false);
    const handlePreviewCustomsDetails = async (item) => {
        setPreviewLoading(true);
        var refnum = item.refnum;
        await Axios.get(`cart/previewcustomsdetails/${refnum.replace('ODR','CAR')}/${item.uuid}`)
            .then(function (response) {
                if (response && response.data?.success) {
                    var pdfdata = response.data.data;
                    var binary_string = atob(pdfdata);
                    var len = binary_string.length;
                    var bytes = new Uint8Array(len);
                    for (var i = 0; i < len; i++) {
                        bytes[i] = binary_string.charCodeAt(i);
                    }
                    const file = new Blob([bytes], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    console.log(fileURL)
                    window.open(fileURL);

                }
            })
        setPreviewLoading(false);
    }

    return (
        <section className="main-container col1-layout">
            <Container className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        <div className="page-title">
                            {confirmedOrder && <div className="heading-counter warning text-center" style={{
                                border: "1px solid #82d783", color: "#3c763d" }}>
                                <i className="fa fa-check" ></i>
                                {/* <span> Your cart subtotal is only <strong>S$79.89</strong> away from free shipping.</span>
                                <span> Your cart subtotal is eligible for <strong>free shipping</strong>.</span> */}
                                <span> Your order has been successfully processed!</span>
                            </div>
                            }
                        </div>
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                <div className="box-border">
                                    <h2>{ "Order Summary" }</h2>
                                    <h3 className="checkout-sep" style={{ paddingBottom: "10px" }}>NO : {cartDetails?.carth?.refnum}</h3>
                                    {cartDetails?.carth?.trandate && <h5><strong>Order Date:</strong> {cartDetails?.carth?.trandate ? (new Date(cartDetails.carth.trandate)).toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) : getDateTime()}</h5>}
                                    <h5><strong>Status:</strong> {cartDetails?.carth?.statusdisplay}</h5>
                                    <br />
                                    {cartDetails.carth?.amended && <p>This order has been amended. <Link target="_blank" to={`/pending-order?refnum=CAR${cartDetails.carth.refnum?.substring(3)}&status=${cartDetails.carth.status}`}>View Original</Link></p>}
                                    <div className="order-detail-content table-responsive">
                                        <table className="table table-bordered jtv-cart-summary">
                                            <thead>
                                                <tr>
                                                    <th className="cart_product">Product</th>
                                                    <th>Description</th>
                                                    <th>Unit price</th>
                                                    <th>Qty</th>
                                                    <th>Total</th>
                                                    {showRefundButton && <th></th>}
                                                </tr>
                                            </thead>
                                            {cartDetails && cartDetails.carth &&  cartDetails.items ?
                                            <>
                                            <tbody>
                                            
                                            {cartDetails.items.map((item,i)=>{
                                                return (
                                                <tr key={i}>
                                                    <td className="cart_product"><Link to="/order-details">
                                                        <img src={AuthVerify.getImageLink(item?.imageurl)} alt="Product" /></Link></td>
                                                    <td className="cart_description"><p className="product-name"><Link to={"/product-detail?matnum="+item?.matnum}> {item?.matname}</Link>{item?.amended && <sup style={{color:"red"}}>*amended</sup>}</p>
                                                        <small className="cart_ref">SKU No.: {item.matnum}</small><br />
                                                        {item.template === 'Y' && <><small className="cart_ref"><button style={{ float: "left", padding: "3px 5px", marginTop: "5px" }} className="button btn-proceed-checkout" title="Details" type="button" onClick={() => handleShowCustomsDetails(item)}>View Details</button></small><br /></>}</td> 
                                                    <td className="price"><span>S${(item.uprice??0).toFixed(2)}</span></td>
                                                    <td className="qty">
                                                        {itemEditable ? <>
                                                        <input className="form-control input-sm" type="number" defaultValue={item.qty} onChange={(event)=>{event.target.value=Math.max(0, Math.min(item.qty, Number(event.target.value)))}} onBlur={(e) => updateCartItems(e, item, e.target.value, true)} />
                                                        {item.qty > 1 && <Link to="/shopping-cart" onClick={(e) => updateCartItems(e, item, -1)}><i className="fa fa-minus"></i></Link>}
                                                        </>: item.qty}
                                                    </td>
                                                    <td className="price"><span>S${(item.amt??0).toFixed(2)}</span></td>
                                                    <td className="a-center last"><span className="nobr"> 
                                                    {itemEditable && <Link to="/shopping-cart" onClick={(e) => deleteCartItems(e, item)}><i className="fa fa-trash-o" style={{ cursor: "pointer", color: "red" }}></i></Link>}
                                                    {showRefundButton && <>
                                                    {itemEditable && <span className="separator">|</span> }
                                                    <button className="btn btn-sm" style={{background:'none',border:'none',color:'blue', fontWeight:'bold'}} title="Exchange" type="button" onClick={()=>handleRefundorExchange(false,true,item.matnum)}><span>Exchange</span></button>
                                                    <span className="separator">|</span> 
                                                    <button className="btn btn-sm" style={{background:'none',border:'none',color:'blue', fontWeight:'bold'}} title="Refund" type="button" onClick={()=>handleRefundorExchange(true,false,item.matnum)}><span>Refund</span></button>
                                                    </>}
                                                    </span>
                                                    </td>
                                                </tr>)
                                            })}
                                            </tbody>
                                            
                                            <tfoot>
                                                <tr>
                                                <td colSpan="2" rowSpan="5">
                                                    <div className="input-group mb-3" style={{
                                                        display: "flex", width: "80%"
                                                    }}>
                                                        <input type="text" id="coupon" name="coupon" title="coupon" className="input form-control"
                                                            placeholder="No Promo Code Applied"
                                                            value={cartDetails?.carth?.promocode}
                                                            readOnly={true}
                                                            style={{
                                                                marginTop: "0px",
                                                                marginRight: "0px",
                                                                padding: "0px"
                                                            }} />
                                                    </div>
                                                </td>
                                                    <td colSpan="2">Subtotal</td>
                                                    <td colSpan="1">S${(cartDetails?.carth?.grossamt??0).toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2"><strong>Discount</strong></td>
                                                    <td colSpan="1"><strong>S${(cartDetails?.carth?.discamt??0).toFixed(2)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2"><strong>Shipping Amount</strong></td>
                                                    <td colSpan="1"><strong>S${(cartDetails?.carth?.shippingamt??0).toFixed(2)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2"><strong>GST</strong></td>
                                                    <td colSpan="1"><strong>S${(cartDetails?.carth?.gstamt??0).toFixed(2)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2"><strong>Grand Total</strong></td>
                                                    <td colSpan="1"><strong>S${(cartDetails?.carth?.totalamt??0).toFixed(2)}</strong></td>
                                                </tr>
                                            </tfoot>
                                            </>:
                                            <tr>
                                                {cartDetails.items!=null ? <td colSpan="6"><Loader/></td>:<td colSpan="6" style={{textAlign:'center'}}>No products found !</td>}
                                            </tr>
                                            }
                                        </table>
                                    </div>
                                </div>
                                
                                <div className="box-border">
                                    <div className="box-account">
                                        <div className="page-title">
                                            <h2>Billing & Shipping Information</h2>
                                        </div>
                                        <div className="col2-set">
                                            <div className="col-1">
                                                <p><strong>Requestor Name:</strong> {cartDetails?.carth?.billptc }<br />
                                                    {/* <strong>Company Name:</strong> {cartDetails?.carth?.shipcountry }<br /> */}
                                                    <strong>Email Address:</strong> {cartDetails?.carth?.billemail }<br />
                                                    <strong>Contact No.:</strong> {cartDetails?.carth?.billphone }<br />
                                                    {/* <Link to="/order-details">Edit</Link> */}
                                                </p>

                                            </div>
                                        </div>
                                        <br />
                                        <div className="col2-set">
                                            <div className="col-1">
                                                <h5>Billing Address</h5>
                                                <address>
                                                {cartDetails?.carth?.billaddr1 }<br />
                                                {cartDetails?.carth?.billcountry }<br />
                                                {cartDetails?.carth?.billpostcode } <br />
                                                    {/* <Link to="/order-details">Edit</Link> */}
                                                </address>
                                            </div>
                                            <div className="col-2">
                                                <h5>Shipping Address</h5>
                                                <address>
                                                    {cartDetails?.carth?.shipaddr1 }<br />
                                                    {cartDetails?.carth?.shipcountry }<br />
                                                    {cartDetails?.carth?.shippostcode } <br />
                                                    {/* <Link to="/order-details">Edit</Link> */}
                                                </address>
                                            </div>
                                        </div>
                                        <hr />
                                        {userDetails?.role==='Corporate' &&
                                        <>
                                        {cartDetails.carth?.budgetdisplay && <>
                                        <h2>Budget Information</h2>
                                        <br/>
                                        <Row>
                                        <Col xs={12} sm={12}>
                                            {/* <div className="recent-orders">
                                                <div className="title-buttons">
                                                    <strong>Budget (Project No.1234 or Cost Center Name)</strong>
                                                </div>
                                            </div> */}
                                            <br/>
                                            <div className="table-responsive">
                                                <table className="data-table" id="my-orders-table">
                                                    <thead>
                                                        <tr className="first last">
                                                            <th></th>
                                                            <th>Total Amount</th>
                                                            <th>Approved Amount</th>
                                                            <th>Pending Amount</th>
                                                            <th>Current Order Amount</th>
                                                            <th>Balance Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr className="first odd">
                                                            <td>Amount:</td>
                                                            <td>{loadBudgetData?.totalamt??0}</td>
                                                            <td>{loadBudgetData?.approvedamt??0}</td>
                                                            <td>{loadBudgetData?.pendingamt??0}</td>
                                                            <td>{loadBudgetData?.currentorderamt??0}</td>
                                                            <td>{loadBudgetData?.balanceamt??0}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>
                                        </Row>
                                        </>}
                                        <hr />
                                        <Row>
                                        <Col md={12}>
                                            <h2>PO Information</h2>
                                            <Col md={3}>
                                                PO No.
                                            </Col>
                                            <Col md={3}>
                                                <input
                                                    Type="text"
                                                    class="form-control"
                                                    readOnly={!allowPOEdit}
                                                    value={cartDetails?.carth?.ponum}
                                                    onChange={(e)=>{cartDetails.carth.ponum=e.target.value; setCartDetails({...cartDetails})}}
                                                />
                                                {allowPOEdit && <a onClick={()=>updatePOHandler()}>Update</a>}
                                            </Col>
                                            <Col md={3}>
                                                Description
                                            </Col>
                                            <Col md={3}>
                                                <input
                                                    Type="text"
                                                    readOnly={true}
                                                    class="form-control"
                                                    value={cartDetails?.carth?.podescription}
                                                />
                                            </Col>
                                        </Col>
                                        </Row>
                                        {cartDetails.carth?.approvaldisplay && <>
                                        <hr />
                                        <div className="page-title">
                                            <h2>Approval Loop</h2>
                                        </div>
                                        <ApprovalLoop carth={cartDetails.carth} justForShow={draftOrder}/>
                                        </>}
                                        <hr />
                                        <Row>
                                        {cartDetails.carth?.shipdeldatedisplay &&<>
                                            <Col md={12}>
                                            <h2>Delivery Date</h2>
                                            {/* <InputField
                                                Labels="Select Date"
                                                Type="text"
                                                disabled={true}
                                                Name="shipdeldate"
                                                // defaultValue={cartDetails.carth?.createdat}
                                            /> */}
                                            <Col md={3}>
                                                Selected Date
                                            </Col>
                                            <Col md={3}>
                                                <input
                                                    type="text"
                                                    name="deliveryType"
                                                    readOnly={true}
                                                    class="form-control"
                                                    value={cartDetails.carth?.shipdeldate?cartDetails.carth?.shipdeldate.split('T')[0]:''}
                                                />
                                            </Col>
                                            </Col>
                                        </>}
                                        {cartDetails.carth?.shipdeldatedisplay && cartDetails.carth?.shipdeldatemessage &&
                                        <Col sm={12} className="heading-counter warning text-center" style={{color:"#f5c328",fontWeight:"bold"}}>
                                            <span>
                                                {cartDetails.carth?.shipdeldatemessage}.
                                            </span>
                                        </Col>
                                        }
                                        </Row>
                                        <hr/>
                                        {cartDetails.shippingmodes && <><h2>Shipping Information</h2>
                                        <div className="box-border">
                                            <ul>
                                            <Row>
                                            <Col sm={6}>
                                                    <label className="required">Shipping Method</label>
                                                    <br />
                                                    {cartDetails.shippingmodes && cartDetails.shippingmodes.map((item,i)=>{
                                                    return (<li key={i}>
                                                        <label style={{ paddingRight: "5px" }}>
                                                        <input
                                                            type="radio"
                                                            name="deliveryType"
                                                            disabled={true}
                                                            value={item.varid}
                                                            checked={item.varid === cartDetails?.carth?.shipmode}
                                                        />
                                                        {item.varvalue}
                                                        </label>
                                                    </li>)
                                                    })}
                                                </Col>
                                            </Row>
                                            </ul>
                                        </div></>} 
                                        {/* {confirmOrder && <>
                                            <h2>Payment Information</h2>
                                            <div className="box-border">
                                                <ul>
                                                    <Col sm={6}>
                                                        <label className="required">Payment Method</label>
                                                        <br />
                                                        {cartDetails.paymodes && cartDetails.paymodes.map((item,i)=>{
                                                        return (<li key={i}>
                                                            <label style={{ paddingRight: "5px" }}>
                                                            <input
                                                                type="radio"
                                                                name="paymode"
                                                                disabled={true}
                                                                value={item.varid}
                                                                checked={item.varid === cartDetails?.carth?.paymode}
                                                            />
                                                            {item.varvalue}
                                                            </label>
                                                        </li>)
                                                        })}
                                                    </Col>
                                                </ul>
                                            </div>
                                        </>} */}
                                        </>
                                        }
                                        {(cartDetails?.carth?.shipdelremark1 || cartDetails?.carth?.shipdelremark2) && 
                                        <>
                                        <hr />
                                        <h2>Remarks</h2>
                                        <div className="col2-set">
                                            <div className="col-1">
                                                 <p><strong>Remark for Invoice : </strong>{cartDetails?.carth?.shipdelremark1 ?? 'N/A' }<br /><br />
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col2-set">
                                            <div className="col-1">
                                                 <p><strong>Message for Sales Support : </strong>{cartDetails?.carth?.shipdelremark2 ?? 'N/A' }<br /><br />
                                                </p>
                                            </div>
                                        </div>
                                        </>
                                        }
                                        <hr />
                                    </div>
                                </div>
                                <div className="cart_navigation" style={{ marginBottom: '10px' }}>
                                    {confirmedOrder && 
                                        <Link to='/' style={{ float: 'right', padding: '0', border: 'none' }}>
                                            <button className="button btn-proceed-checkout" title="Proceed to Checkout" type="button"><span>Back to Home</span></button>
                                        </Link>
                                    }
                                    {draftOrder && 
                                        // <Link to='/shopping-cart' style={{ float: 'right', padding: '0', border: 'none' }}>
                                            <button className="button btn-proceed-checkout" title="Proceed to Checkout" type="button" onClick={()=>checkCartItems()}><span>Load to Cart</span></button>
                                        // </Link>
                                    }

                                    {showConfirmButton &&
                                        <button className="button btn-proceed-checkout" title="Proceed to Checkout" type="button" onClick={()=>confirmOrderHandler()}><span>Confirm Order</span></button>
                                    }

                                    {showReOrderButton &&
                                        <button className="button btn-proceed-checkout" title="Reorder" type="button" onClick={()=>checkCartItems(true)}><span>Reorder</span></button>
                                    }

                                    <button onClick={()=>{setSaveAsTemplateModal(true)}} className="button btn-proceed-checkout" title="Save As Template" type="button">
                                        <span>Save As Template</span>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container >

            <Modal show={saveAsTemplateModal} dialogClassName="modal-90w" animation={false} fade={false} style={{opacity:1}} onHide={()=>setSaveAsTemplateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Template Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Formik
          initialValues={{templateName:'',templateRemarks:''}}
          validationSchema={Yup.object().shape({
            templateName: Yup.string().required("Name is required !"),
            templateRemarks: Yup.string().required("Remarks is required !")
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(false);
            saveAsTemplate(values);
          }}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              errors, touched
            } = props;
            return (
              <Form onSubmit={handleSubmit}>
                <div className="box-border">
                  <div className="form-list">
                      <Row>
                        <Col xl={6} sm={6}>
                          <InputField
                            Name="templateName"
                            id="templateName"
                            Labels="Template Name"
                            Type="text"
                            value={values.templateName}
                            onChange={handleChange}
                            isInvalid={!!errors.templateName}
                            className={(errors.templateName && touched.templateName) ? 'is-invalid' : 'form-control'}
                          />
                        </Col>
                        <Col xl={6} sm={6}>
                            <InputField
                              Name="templateRemarks"
                              id="templateRemarks"
                              Labels="Template Remarks"
                              Type="text"
                              value={values.templateRemarks}
                              onChange={handleChange}
                              isInvalid={!!errors.templateRemarks}
                              className={(errors.templateRemarks && touched.templateRemarks) ? 'is-invalid' : 'form-control'}
                            />
                            </Col>
                        </Row>
                  </div>
                </div>
                <Row>
                <div className="cart_navigation">
                  <button
                    className="button btn-proceed-checkout btn-danger"
                    title="Proceed to Checkout"
                    type="button"
                    onClick={()=>setSaveAsTemplateModal(false)}
                    style={{
                      marginRight: "10px",
                      padding: "10px"
                    }}
                  >
                    <span>Close</span>
                  </button>

                    <button
                      className="button btn-proceed-checkout"
                      title="Proceed to Checkout"
                      type="submit"
                      style={{
                        marginRight: "10px",
                        background: "#337ab7",
                        border: "0px solid #337ab7",
                        padding: "10px"
                      }}
                    >
                      <span>Save As Template</span>
                    </button>
                </div>
                
                </Row>
              </Form>
            );
          }}
        </Formik>
        </Modal.Body>
      </Modal>

            <Modal show={askingForDraft} size="sm" centered animation={false} fade={false} style={{opacity:1,margin:"auto"}} onHide={()=>setAskingForDraft(false)}>
                <Modal.Header closeButton={false}>
                    <Modal.Title>There are some products found in your cart !</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{textAlign:"center"}}>
                {reOrder? 'Do you want to save those products as draft for further use ?':
                'This action will overwrite current cart.'}
                </Modal.Body>
                <Modal.Footer>
                <div  style={{float:"right"}}>
                    <button
                    className="button "
                    title="Overwrite"
                    type="button"
                    onClick={() => {loadToCart()}}
                    style={{
                        marginRight: "10px",
                        padding: "5px"
                    }}
                    >
                    <span>Overwrite</span>
                    </button>
                    <button
                    className="button button-danger"
                    title="Save current as draft"
                    type="button"
                    onClick={() => {saveAsDraft()}}
                    style={{
                        marginRight: "10px",
                        padding: "5px"
                    }}
                    >
                    <span>Save current as draft</span>
                    </button>
                </div>
                </Modal.Footer>
            </Modal>

            <Modal show={showRefundModal} size="lg" centered animation={false} fade={false} style={{opacity:1,margin:"auto"}} onHide={()=>setShowRefundModal(false)}>
                <Modal.Header closeButton={false}>
                    <Modal.Title>Refund request.</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Formik
                initialValues={{
                  reason: "",
                  qty: "",
                  newmatnum:""
                }}
                validationSchema={Yup.object().shape({
                  qty: Yup.number().required("Exchange Quatity is required"),
                  reason: Yup.string().required("Reason is required")
                })}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  handleRefundorExchangeSubmit(showRefundModal,showExchangeModal,values);
                  setSubmitting(false);
                  resetForm();
                }}
              >
                {(props) => {
                  const {
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    isSubmitting,
                    handleSubmit,
                  } = props;
                  return (
                    <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col xs={2} sm={2}></Col>
                        <Col xs={10} sm={10}>
                        <div className="table-responsive">
                            <table className="data-table" id="my-orders-table">
                                <thead>
                                    <tr className="first last">
                                        <th>Product</th>
                                        <th>Description</th>
                                        <th>Unit Price</th>
                                        <th>Order Qty</th>
                                        <th>Refund Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="first odd">
                                        <td className="cart_product">
                                            <img src={AuthVerify.getImageLink(selectedProductDetails?.imageurl)} alt={selectedProductDetails.matname} style={{maxWidth:"100px"}}/>
                                        </td>
                                        <td>{selectedProductDetails.matname}</td>
                                        <td>{selectedProductDetails.uprice}</td>
                                        <td>{selectedProductDetails.qty}</td>
                                        <td>
                                            <input
                                                style={{width:"100%"}}
                                                Type="number"
                                                Name="qty"
                                                value={values.qty}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.qty}
                                                className={(errors.qty && touched.qty? " is-invalid": "")}/>
                                            <br/>
                                            {errors.qty && touched.qty && (<span style={{color: "red",float:"right"}}>{errors.qty}{" ! "}</span>)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        </Col>
                        <Col xs={2} sm={2} style={{marginTop:'10px'}}>Reason</Col>
                        <Col xs={10} sm={10} style={{marginTop:'10px'}}>
                            <textarea
                                style={{width:"100%",float:'right'}}
                                Name="reason"
                                value={values.reason}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isInvalid={!!errors.reason}
                                className={(errors.reason && touched.reason? " is-invalid": "")}></textarea>
                            <br/>
                            {errors.reason && touched.reason && (<span style={{color: "red",float:'right'}}>{errors.reason}{" ! "}</span>)}
                        </Col>

                        <Col xs={2} sm={2} style={{marginTop:'10px'}}>Add Image</Col>
                        <Col xs={10} sm={10} style={{marginTop:'10px'}}>
                            <input type='file'></input>
                        </Col>
                    </Row>
                    <div  style={{float:"right"}}>
                            <button
                            className="btn btn-primary"
                            title="Submit"
                            type="submit"
                            style={{
                                marginRight: "10px",
                                padding: "5px"
                            }}
                            >
                            <span>Submit</span>
                            </button>

                            <button
                            className="btn btn-danger"
                            title="Close"
                            type="button"
                            onClick={() => {setShowRefundModal(false)}}
                            style={{
                                marginRight: "10px",
                                padding: "5px"
                            }}
                            >
                            <span>Close</span>
                            </button>
                        </div>
                        <br/>
                        <br/>
                    </Form>
                  );
                }}
              </Formik>
                </Modal.Body>
            </Modal>

            <Modal show={showExchangeModal} size="lg" centered animation={false} fade={false} style={{opacity:1,margin:"auto"}} onHide={()=>setShowExchangeModal(false)}>
                <Modal.Header closeButton={false}>
                    <Modal.Title>Exchange request.</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Formik
                initialValues={{
                  reason: "",
                  qty: "",
                  newmatnum:""
                }}
                validationSchema={Yup.object().shape({
                  qty: Yup.number().required("Exchange Quatity is required"),
                  reason: Yup.string().required("Reason is required"),
                  newmatnum: Yup.string().required("Exchange product is required"),
                })}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  handleRefundorExchangeSubmit(showRefundModal,showExchangeModal,values);
                  setSubmitting(false);
                  resetForm();
                }}
              >
                {(props) => {
                  const {
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    isSubmitting,
                    handleSubmit,
                  } = props;
                  return (
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col xs={2} sm={2}></Col>
                            <Col xs={10} sm={10}>
                            <div className="table-responsive">
                                <table className="data-table" id="my-orders-table">
                                <thead>
                                        <tr className="first last">
                                            <th>Product</th>
                                            <th>Description</th>
                                            <th>Unit Price</th>
                                            <th>Order Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="first odd">
                                            <td className="cart_product">
                                                <img src={AuthVerify.getImageLink(selectedProductDetails?.imageurl)} alt={selectedProductDetails.matname} style={{maxWidth:"100px"}}/>
                                            </td>
                                            <td>{selectedProductDetails.matname}</td>
                                            <td>{selectedProductDetails.uprice}</td>
                                            <td>{selectedProductDetails.qty}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            </Col>

                            <Col xs={2} sm={2} style={{marginTop:'10px'}}></Col>
                            <Col xs={5} sm={5} style={{marginTop:'10px'}}>
                                Exchange to:
                            </Col>
                            <Col xs={5} sm={5} style={{marginTop:'10px'}}>
                                <select
                                    style={{width:"90%",float:'right'}}
                                    Name="newmatnum"
                                    value={values.newmatnum}
                                    onChange={(e)=>{handleChange(e); setNewSelectedProductDetails(suggestedProducts.filter(x=>x.matnum===e.target.value)[0]);}}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.newmatnum}
                                    className={(errors.newmatnum && touched.newmatnum? " is-invalid": "")}>
                                        <option value="" disabled>Select exchange product</option>
                                        {suggestedProducts && suggestedProducts.map((index,i)=>{
                                            return (
                                            <option value={index.matnum} key={i}>{index.matname}</option>
                                            )
                                        })}
                                    </select>
                                <br/>
                                {errors.newmatnum && touched.newmatnum && (<span style={{color: "red",float:'right'}}>{errors.newmatnum}{" ! "}</span>)}
                            
                            </Col>

                            <Col xs={2} sm={2} style={{marginTop:'10px'}}></Col>
                            <Col xs={10} sm={10} style={{marginTop:'10px'}}>
                            <div className="table-responsive">
                                <table className="data-table" id="my-orders-table">
                                <thead>
                                        <tr className="first last">
                                            <th>Product</th>
                                            <th>Description</th>
                                            <th>Unit Price</th>
                                            <th>Exchange Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="first odd">
                                            <td>
                                                {newSelectedProductDetails && <img src={AuthVerify.getImageLink(newSelectedProductDetails?.imageurl)} alt={newSelectedProductDetails.matname} style={{maxWidth:"100px"}}/>}
                                            </td>
                                            <td>{newSelectedProductDetails?.matname}</td>
                                            <td>{newSelectedProductDetails?.sellingprice}</td>
                                            <td>
                                            <input
                                                style={{width:"100%"}}
                                                Type="number"
                                                Name="qty"
                                                value={values.qty}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.qty}
                                                className={(errors.qty && touched.qty? " is-invalid": "")}/>
                                            <br/>
                                            {errors.qty && touched.qty && (<span style={{color: "red",float:"right"}}>{errors.qty}{" ! "}</span>)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            </Col>

                            <Col xs={2} sm={2} style={{marginTop:'10px'}}>Reason</Col>
                            <Col xs={10} sm={10} style={{marginTop:'10px'}}>
                                <textarea
                                    style={{width:"100%",float:'right'}}
                                    Name="reason"
                                    value={values.reason}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.reason}
                                    className={(errors.reason && touched.reason? " is-invalid": "")}></textarea>
                                <br/>
                                {errors.reason && touched.reason && (<span style={{color: "red",float:'right'}}>{errors.reason}{" ! "}</span>)}
                            </Col>

                            <Col xs={2} sm={2} style={{marginTop:'10px'}}>Add Image</Col>
                            <Col xs={10} sm={10} style={{marginTop:'10px'}}>
                                <input type='file'></input>
                            </Col>
                        </Row>
                        <div  style={{float:"right"}}>
                            <button
                            className="btn btn-primary"
                            title="Submit"
                            type="submit"
                            style={{
                                marginRight: "10px",
                                padding: "5px"
                            }}
                            >
                            <span>Submit</span>
                            </button>

                            <button
                            className="btn btn-danger"
                            title="Close"
                            type="button"
                            onClick={() => {setShowExchangeModal(false)}}
                            style={{
                                marginRight: "10px",
                                padding: "5px"
                            }}
                            >
                            <span>Close</span>
                            </button>
                        </div>
                        <br/>
                        <br/>
                    </Form>
                  );
                }}
              </Formik>

                </Modal.Body>
            </Modal>

            <Modal show={showCustomsDetails} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setShowCustomsDetails(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedCartItem.matname}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                    <div className="order-detail-content">
                        <Table responsive className="osya table-bordered jtv-cart-summary">
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <th>Qty</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {
                                customsDetails && customsDetails.items ?
                                    <>
                                        <tbody>
                                            {customsDetails?.items.map((item, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td className="cart_description">
                                                            <p className="product-name">{item.description} </p>
                                                        </td>
                                                        <td className="qty">
                                                            <input className="form-control input-sm" type="text" defaultValue={item.qty} readOnly={true} />
                                                        </td>
                                                        <td className="action">
                                                            <small className="cart_ref"><button style={{ float: "left", padding: "3px 5px", marginTop: "5px" }} className="button btn-proceed-checkout" title="Preview" type="button" onClick={() => handlePreviewCustomsDetails(item)} disabled={previewLoading}>{previewLoading ? 'Loading Preview' : 'Preview'}</button></small>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                            }
                                        </tbody>
                                    </>
                                    :
                                    <>
                                        <tbody>
                                            <tr>
                                                <td colSpan={8} style={{ textAlign: "center" }}>
                                                    Details not found!
                                                </td>
                                            </tr>
                                        </tbody>
                                    </>
                            }
                        </Table>
                    </div>
                </Modal.Body>
            </Modal>

        </section >
    )
}
export default OrderDetails;

